import { colorsPalettes } from "@similarweb/styles";

export const KEYWORD_PLACEHOLDER = "#";

export const ZERO = 0;
export const PRELOADER_COUNT = 5;

export const loadingOptions = {
    svg: {
        stroke: colorsPalettes.midnight[50],
        strokeWidth: "4",

        r: 8,
        cx: "50%",
        cy: "50%",
    },
    style: {
        width: 46,
        height: 46,
    },
};
